import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { DashboardService } from 'app/services/dashboard.service';
import { GlobalsService } from 'app/services/globals.service';
import { ReportsService } from 'app/services/reports.service';
import { report } from 'process';
import { forkJoin, Subscription } from 'rxjs';
import { buildDashboardThemeVars } from '../dashboard-widget-theme';
import { Sort } from '@angular/material/sort';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { PrintService } from 'app/services/print.service';

@Component({
	selector: 'app-salesman-scoreboard',
	templateUrl: './salesman-scoreboard.component.html',
	styleUrls: ['./salesman-scoreboard.component.scss']
})

export class SalesmanScoreboardComponent implements OnInit {

	reportrun: Subscription | Boolean;
	@Input() config: any = false;
	@Input() userdata: any = false;

	get themeVars(): Record<string, string> {
		return buildDashboardThemeVars('ss', 'orange');
	}

	defaultlocation: any = false;
	locationref = new UntypedFormControl('');
	yearref = new UntypedFormControl('');
	monthref = new UntypedFormControl('');
	allowedlocs: any = [];
	years = [];
	months = [];


	currentMonth: any = false;
	currentYear: any = false;
	reportdata: any = false;
	showdetails: any = false;
	totals: any = false;
	sortedData: any = false;
	mainsort: any = false;
	

	constructor(private printService: PrintService, private globalSearchService: GlobalSearchService, private globalsService: GlobalsService, private dashboardService: DashboardService){}


	ngOnInit(): void {
		this.globalsService.getUserLocations().subscribe((locs: [])=>{
			this.allowedlocs = (locs ?? []).map((loc: any)=>{ return {value: loc.loccode, view: loc.locationname} });
			//one location - no change
			if(this.allowedlocs.length == 1){
				this.locationref.disable();
			}
		});

		if(this.userdata){
			console.log(this.userdata);
			this.locationref.setValue(this.userdata.user.defaultlocation.loccode);
		}

		this.builddates();
		this.runreport()
	}

	builddates(){
		this.months = [ {value: '01', view: 'January'}, {value: '02', view: 'Febuary'}, {value: '03', view: 'March'}, {value: '04', view: 'April'}, {value: '05', view: 'May'}, {value: '06', view: 'June'}, {value: '07', view: 'July'}, {value: '08', view: 'August'}, {value: '09', view: 'Sepetember'}, {value: '10', view: 'October'}, {value: '11', view: 'November'}, {value: '12', view: 'December'} ]
		this.years = Array.from({ length: 6 }, (_, i) => Number(new Date().getFullYear()) - i);
		this.currentYear =  Number(new Date().getFullYear());
		this.currentMonth = String(new Date().getMonth() + 1).padStart(2, "0");

		
		this.yearref.setValue(this.currentYear);
		this.monthref.setValue(this.currentMonth);
	}


	runreport(){
		if(this.reportrun instanceof Subscription){
			this.reportrun.unsubscribe();
		}

		const rundata = {
			userid:this.userdata.user.userid,
			location:this.locationref.value,
			salesman:this.userdata.user.salesman,
			month:this.monthref.value,
			year:this.yearref.value.toString()
		}

		this.monthref.disable();
		this.yearref.disable();

		this.reportrun = this.dashboardService.getScoreboard(rundata).subscribe((rep)=>{
			this.reportrun = false;
			this.setReport(rep);
		});
	}




	setReport(rep){
		let rows = rep.formated_results;
		//push zeros to end
		rows.sort((a,b)=>{
			if(a.sort == 0 ){return 1}
			if(b.sort == 0 ){return 1}
		})
		//sort by descending		
		rows.sort((a, b) => b.sort - a.sort);

		
		rep.formated_results = rows;
		this.totals = rep.formated_results[0];
		this.reportdata = rep;
		this.sortedData = rep.formated_results;
		this.mainsort = [...this.sortedData];
		this.monthref.enable();
		this.yearref.enable();
		this.reportrun = false;

		
	}


	



	export(type){
		const html = this.buildhtml()
		const encoded: string = this.globalSearchService.base64encode(html);
		const today = new Date('Y-m-d');
		
		const data = {
			content: encoded,
			filename: `scoreboard-${this.userdata.user.userid}-${today}`,
			title: `Sales Scoreboard`,
			subtitle: `${this.reportdata?.title} ${this.reportdata?.subtitle}`
		}


		if(type == 'pdf'){
			this.printService.pdf(data).subscribe((result: any) => {
				this.globalSearchService.downloadPdf(result.content, data.filename);
			});
		}else{
			this.printService.xls(data).subscribe((result: any) => {
				this.globalSearchService.downloadXls(result.content, data.filename);
			});
		}
		
		
	}


	

	buildhtml(){
		let html  = '<table><thead><tr>';
			html += `<th>Name</th>`
			html += `<th>Actives</th>`
			html += `<th>Actives LY</th>`
			html += `<th>Actives DIFF</th>`
			html += `<th>Sales</th>`
			html += `<th>Sales LY</th>`
			html += `<th>Sales DIFF</th>`
			html += `<th>Sales DIFF %</th>`
			html += `<th>Sales YTD</th>`
			html += `<th>Sales YTD LY</th>`
			html += `<th>Sales YTD DIFF</th>`
			html += `</tr></thead><tbody>`

		this.reportdata.formated_rows.forEach((row)=>{
			if(row.name !== 'total'){
				html += `<tr>`
				html += `<td>${row.name}</td>`
				html += `<td>${row.actives}</td>`
				html += `<td>${row.acticesly}</td>`
				html += `<td>${row.activesdiff}</td>`
				html += `<td>${row.sales}</td>`
				html += `<td>${row.salesly}</td>`
				html += `<td>${row.salesdiff}</td>`
				html += `<td>${row.salesdiffpercent}</td>`
				html += `<td>${row.salesytd}</td>`
				html += `<td>${row.salesytdly}</td>`
				html += `<td>${row.salesytddiff}</td>`
				html += `</tr>`
			}
		})

			html += `<tr>`
			html += `<td>${this.reportdata.formated_results[0].name}</td>`
			html += `<td>${this.reportdata.formated_results[0].actives}</td>`
			html += `<td>${this.reportdata.formated_results[0].acticesly}</td>`
			html += `<td>${this.reportdata.formated_results[0].activesdiff}</td>`
			html += `<td>${this.reportdata.formated_results[0].sales}</td>`
			html += `<td>${this.reportdata.formated_results[0].salesly}</td>`
			html += `<td>${this.reportdata.formated_results[0].salesdiff}</td>`
			html += `<td>${this.reportdata.formated_results[0].salesdiffpercent}</td>`
			html += `<td>${this.reportdata.formated_results[0].salesytd}</td>`
			html += `<td>${this.reportdata.formated_results[0].salesytdly}</td>`
			html += `<td>${this.reportdata.formated_results[0].salesytddiff}</td>`
			html += `</tr>`

			html += `</tbody></table>`;
			
		
	}




	sortData(sort: Sort) {
		const data = [...this.mainsort];
		if (!sort.active || sort.direction === '') {
			this.sortedData = data;
			return;
		}
		this.sortedData = data.sort((a, b) => {
			const dir = sort.direction === 'asc';
			switch (sort.active) {
				case 'actives': return this.compare(a.actives, b.actives, dir);
				case 'activesly': return this.compare(a.activesly, b.activesly, dir);
				case 'sales': return this.compare(a.sales, b.sales, dir);
				case 'salesly': return this.compare(a.salesly, b.salesly, dir);
				case 'salesdiffpercent': return this.compare(a.salesdiffpercent, b.salesdiffpercent, dir);
				case 'salesytd': return this.compare(a.salesytd, b.salesytd, dir);
				case 'salesytdly': return this.compare(a.salesytdly, b.salesytdly, dir);
				default: return 0;
			}
		});
	}

	compare(a, b, isAsc: boolean) {
		if (typeof a === 'string') {
			a = a.replace('$', '').replace(',', '').replace('%', '');
		}
		if (typeof b === 'string') {
			b = b.replace('$', '').replace(',', '').replace('%', '');
		}
		return (parseFloat(a) < parseFloat(b) ? -1 : 1) * (isAsc ? 1 : -1);
	}

}
